<template>
  <page-view :title="true">
    <a-card>
      <a-descriptions title="基本信息">
        <a-descriptions-item label="出租方式">{{
          houseInfo.rentTypeName
        }}</a-descriptions-item>
        <a-descriptions-item label="小区">{{
          houseInfo.communityName
        }}</a-descriptions-item>
        <a-descriptions-item label="户型">{{
          houseInfo.roomLayoutName
        }}</a-descriptions-item>
        <a-descriptions-item label="楼号">{{
          houseInfo.buildingNo
        }}</a-descriptions-item>
        <a-descriptions-item label="单元号">{{
          houseInfo.unitNo
        }}</a-descriptions-item>
        <a-descriptions-item label="门牌号">{{
          houseInfo.houseNum
        }}</a-descriptions-item>
        <a-descriptions-item label="当前楼层">{{
          houseInfo.floor
        }}</a-descriptions-item>
        <a-descriptions-item label="总楼层">{{
          houseInfo.totalFloor
        }}</a-descriptions-item>
        <a-descriptions-item label="管家">{{
          houseInfo.keeperName
        }}</a-descriptions-item>
        <a-descriptions-item label="采暖方式">{{
          houseInfo.heatingTypeName
        }}</a-descriptions-item>
        <a-descriptions-item label="描述" :span="2">{{
          houseInfo.roomIntro
        }}</a-descriptions-item>
      </a-descriptions>
      <a-divider />
      <a-descriptions title="其他信息">
        <a-descriptions-item label="房源名称">{{
          houseInfo.houseName
        }}</a-descriptions-item>
        <a-descriptions-item label="房号">{{
          houseInfo.roomNum
        }}</a-descriptions-item>
        <a-descriptions-item label="朝向">{{
          houseInfo.roomDirection
        }}</a-descriptions-item>
        <a-descriptions-item label="付款方式">{{
          houseInfo.payWayName
        }}</a-descriptions-item>
        <a-descriptions-item label="租金(元/月)"
          >￥{{ houseInfo.rent }}</a-descriptions-item
        >
        <a-descriptions-item label="面积"
          >{{ houseInfo.roomArea }}㎡</a-descriptions-item
        >
        <a-descriptions-item label="最短租期(月)">{{
          houseInfo.shortLease
        }}</a-descriptions-item>
        <a-descriptions-item label="限住人数">{{
          houseInfo.limitNum
        }}</a-descriptions-item>
        <a-descriptions-item label="租期">{{
          houseInfo.isShortRent == "0" ? "长租" : "短租"
        }}</a-descriptions-item>
        <a-descriptions-item label="水费(元)"
          >￥{{ houseInfo.waterCost }}</a-descriptions-item
        >
        <a-descriptions-item label="电费(元)"
          >￥{{ houseInfo.electricityCost }}</a-descriptions-item
        >
        <a-descriptions-item label="天然气费(元)"
          >￥{{ houseInfo.naturalGasCost }}</a-descriptions-item
        >
        <a-descriptions-item label="暖气费(元)"
          >￥{{ houseInfo.heatingCost }}</a-descriptions-item
        >
        <a-descriptions-item label="物业费(元)"
          >￥{{ houseInfo.propertyFee }}</a-descriptions-item
        >
        <a-descriptions-item label="网费(元)"
          >￥{{ houseInfo.internetFee }}</a-descriptions-item
        >
        <a-descriptions-item label="服务费(元)"
          >￥{{ houseInfo.serviceFee }}</a-descriptions-item
        >
        <a-descriptions-item label="配件" :span="2">{{
          accessories
        }}</a-descriptions-item>
      </a-descriptions>
      <a-divider />
      <a-descriptions title="图片"></a-descriptions>

      <div class="gallery">
        <a-upload
          @preview="handlePreview"
          listType="picture-card"
          :showUploadList="{ showPreviewIcon: true, showRemoveIcon: false }"
          :fileList="houseInfo.fileList"
        ></a-upload>
      </div>
      <div class="operation"><a-button @click="back">返回</a-button></div>
    </a-card>

    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel"
      ><img alt="example" style="width: 100%" :src="previewImage"
    /></a-modal>
  </page-view>
</template>

<script>
import { PageView } from "@/layouts";
export default {
  components: {
    PageView
  },
  name: "HouseInfo",
  data() {
    return {
      houseNo: "",
      keeperNo: undefined,
      queryParam: null,
      baseInfo: {
        heatingTypeList: [],
        payWayList: [],
        rentTypeList: [],
        roomLayoutList: [],
        roomPartList: [],
        floorList: [],
        totalFloorList: [],
        keeperList: []
      },
      houseInfo: {},
      accessories: "", //配件信息
      tempPartList: [],
      houseImageList: [],
      previewVisible: false,
      previewImage: ""
    };
  },
  created() {
    let query = this.$route.query;
    if (query.keeperNo) {
      this.keeperNo = query.keeperNo;
    }
    if (query.houseNo) {
      this.houseNo = query.houseNo;
      this.getHouseInfo();
    }
    if (query.param) {
      this.queryParam = query.param;
    }
    this.getBaseInfo();
  },
  watch: {
    tempPartList() {
      this.checkPart();
    },
    "baseInfo.roomPartList"() {
      this.checkPart();
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: "HouseList",
        query: { param: this.queryParam }
      });
    },
    async getBaseInfo() {
      this.$http.roomBksApi.findHouseKindData().then(res => {
        Object.assign(this.baseInfo, res.resultObject);
        for (let i = 1; i < 100; i++) {
          this.baseInfo.floorList.push(i);
          this.baseInfo.totalFloorList.push(i);
        }
      });
    },
    async getHouseInfo() {
      this.$http.roomBksApi
        .findHouseInfoByHouseNo({ houseNo: this.houseNo })
        .then(res => {
          let obj = Object.assign({}, this.houseInfo);
          this.houseInfo = Object.assign(obj, res.resultObject);
          this.houseInfo.keeperNo = this.keeperNo;
          this.tempPartList = this.houseInfo.roomPartList;
        });
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    checkPart() {
      let str = "";
      for (let p of this.tempPartList) {
        for (let item of this.baseInfo.roomPartList) {
          if (p == item.dictCode) {
            str += item.dictName + ",";
          }
        }
      }
      if (str) {
        this.accessories = str.substring(0, str.length - 1);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.gallery {
  display: flex;
  flex-wrap: wrap;
  .gallery-item {
    height: 100px;
    width: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.operation {
  text-align: center;
  margin: 20px auto 5px;
}
</style>
